import {
  DEFAULT_QUIET_HOURS,
  isQuietHour,
} from '../../config/aiFollowUpQuietHours';

// "9:00" to "09:00": the engine accepts both, a time input only the second.
const padQuietHour = (value) => {
  const [hours, minutes] = String(value).trim().split(':');
  return `${hours.padStart(2, '0')}:${minutes}`;
};

/**
 * The form values for the band of a `followUp` object. Mirrors the engine's
 * normaliseQuietHours: both ends valid or the default for both, because that
 * is what runs — showing the valid half would show a band that does not.
 */
export const formatQuietHours = (followUp) => {
  const raw = (followUp && followUp.quietHours) || {};
  const start = typeof raw.start === 'string' ? raw.start.trim() : '';
  const end = typeof raw.end === 'string' ? raw.end.trim() : '';
  const band =
    isQuietHour(start) && isQuietHour(end)
      ? { start, end }
      : DEFAULT_QUIET_HOURS;

  return {
    quietHoursStart: padQuietHour(band.start),
    quietHoursEnd: padQuietHour(band.end),
  };
};

/**
 * The `followUp.quietHours` the engine reads, from the form values. Throws on
 * a missing or malformed end: the engine would silently run the default in
 * its place, and a failed save is better than a band nobody chose.
 */
export const parseQuietHours = ({ quietHoursStart, quietHoursEnd }) => {
  const start = String(quietHoursStart ?? '').trim();
  const end = String(quietHoursEnd ?? '').trim();
  if (!isQuietHour(start) || !isQuietHour(end))
    throw new Error('Both ends of the night band must be times as HH:mm');

  return { start: padQuietHour(start), end: padQuietHour(end) };
};

// Equal ends are a legitimate choice, no band: the form says so under them.
export const hasNoQuietHours = (start, end) =>
  isQuietHour(start) &&
  isQuietHour(end) &&
  padQuietHour(start) === padQuietHour(end);
